// 1. On définit la liste de tes couleurs
const colors = ['#F3D351', '#A9ABFF', '#6DD6FF', '#CEDC75', '#FF7F2A', '#FF79BB'];

// 2. On sélectionne tous les éléments ciblés par tes classes CSS
const elements = document.querySelectorAll(`
  .rich-text .rich-text-sub-heading,
  .bls__image-with-text .sub-heading, 
  .bls_faq-section .bls__section-header .heading-font,
  .bls__shopable-video .heading-font
`);

// 3. On applique une couleur aléatoire à chaque élément trouvé
elements.forEach(element => {
  const randomColor = colors[Math.floor(Math.random() * colors.length)];
  element.style.color = randomColor;
});